
import {Component, Vue} from 'vue-facing-decorator';
import {closeWidget} from "@/utils";

@Component
export default class Success extends Vue {
  close = closeWidget
}
